import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { RegistrationService } from '../../services/registration.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'registration/validateemail',
    template: require('./validate.email.component.html'),
    styles: [require('./validation.component.css')]
})
export class ValidateEmailComponent implements OnInit {
    routeParamsSub: Subscription;
    emailToken: string;

    constructor(private router: Router,
        private route: ActivatedRoute,
        private registrationService: RegistrationService) { }

    ngOnInit() {
        if (this.routeParamsSub) this.routeParamsSub.unsubscribe();
        this.routeParamsSub = this.route.params.subscribe(params => {
            this.emailToken = params['id'];

            this.sendValidationToken();
        });
    }

    sendValidationToken() {
        this.registrationService.validateEmail(this.emailToken).subscribe(() => {
            this.router.navigateByUrl('/registration/validationComplete');
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/registration/validate.email.component.ts